import React, { useEffect, useState } from 'react';
import { RegexUtil } from '../../../../common/utils/regexUtil';

const MypageExpList = ({ items = [] }) => {
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (items.length > 0) {
      setIsLoading(false);
    } else {
      setIsLoading(true);
    }
  }, []);

  const ExpItem = ({ item, i }) => {
    const subItems = item.items || [];
    const [expanded, setExpanded] = useState(false);

    const totalExp = parseInt(item.get_exp, 10) + parseInt(item.use_exp, 10);

    let expClass = 'point_num zero';
    if (totalExp > 0) {
      expClass = 'point_num exp_num';
    } else if (totalExp < 0) {
      expClass = 'point_num minus';
    }

    return (
      <div
        className="point_item_container"
        key={i}
        onClick={() => {
          if (subItems.length > 0) {
            setExpanded(!expanded);
          }
        }}
      >
        <div className={'point_item'} key={`main-item-${i}`}>
          <span className="info">
            <em className="tx">{item.po_content}</em>
            <em className="date">{item.last_time || item.po_datetime}</em>
          </span>
          <div className="point_num_container">
            <span className={expClass}>
              {totalExp !== undefined
                ? totalExp > 0
                  ? '+' + RegexUtil.makeComma(totalExp)
                  : RegexUtil.makeComma(totalExp)
                : 0}
            </span>
            <div className="img_container">
              {subItems.length > 0 && (
                <img src="/images/chevron_right.svg" alt="Expand" className={expanded ? 'rotated' : ''} />
              )}
            </div>
          </div>
        </div>

        {expanded &&
          subItems.length > 0 &&
          subItems.map((subItem, subIndex) => {
            let subExpClass = 'point_num zero';
            const subExp = parseInt(subItem.po_exp, 10);
            if (subExp > 0) {
              subExpClass = 'point_num exp_num';
            } else if (subExp < 0) {
              subExpClass = 'point_num minus';
            }
            return (
              <div className="point_sub_item" key={`sub-item-${i}-${subIndex}`}>
                <span className="info">
                  <em className="tx">{subItem.po_content}</em>
                  <em className="date">{subItem.created_at || subItem.po_datetime}</em>
                </span>
                <span className={subExpClass}>
                  {subExp !== undefined
                    ? subExp > 0
                      ? '+' + RegexUtil.makeComma(subExp)
                      : RegexUtil.makeComma(subExp)
                    : 0}
                </span>
                <div className="img_container" />
              </div>
            );
          })}
      </div>
    );
  };

  return (
    <div className="list">
      {items.map((item, index) => (
        <ExpItem item={item} i={index} key={index} />
      ))}
    </div>
  );
};

export { MypageExpList };
